// Centralized typography definitions for consistent font sizing across the app

export const typography = {
  // Headers
  h1: '2rem',           // 32px - Main page titles
  h2: '1.5rem',         // 24px - Section headers
  h3: '1.25rem',        // 20px - Subsection headers
  h4: '1.125rem',       // 18px - Card headers
  
  // Body text
  base: '1rem',         // 16px - Default body text
  sm: '0.875rem',       // 14px - Small text, labels
  xs: '0.75rem',        // 12px - Very small text, captions
  
  // Data display
  dataLarge: '1.25rem', // 20px - Large data values (reduced from 24px)
  dataMedium: '1rem',   // 16px - Medium data values (reduced from 18px)
  dataSmall: '0.875rem', // 14px - Small data values (reduced from 16px)
  
  // Table
  tableHeader: '0.875rem', // 14px - Table headers (reduced from 16px)
  tableCell: '1rem',       // 16px - Table cells (reduced from 18px)
  
  // UI elements
  button: '0.875rem',   // 14px - Button text
  caption: '0.75rem',   // 12px - Captions, helper text
} as const;

export type TypographySize = keyof typeof typography;

// Responsive spacing utilities
export const spacing = {
  // Table padding - responsive
  tablePadding: {
    desktop: '1.5rem 1rem',  // 24px vertical, 16px horizontal
    mobile: '0.75rem 0.5rem' // 12px vertical, 8px horizontal
  },
  tableCellPadding: {
    desktop: '1.25rem 1rem',  // 20px vertical, 16px horizontal  
    mobile: '0.75rem 0.5rem'  // 12px vertical, 8px horizontal
  }
} as const;
